/* eslint-disable */
import { PluginContainerData, Media } from './common.js';

export interface AudioData {
  /** Styling for the audio node's container. */
  containerData?: PluginContainerData;
  /** Audio file details. */
  audio?: Media;
  /** Sets whether the audio node's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean;
  /** Cover image. */
  coverImage?: Media;
  /** Track name. */
  name?: string;
  /** Author name. */
  authorName?: string;
  /** An HTML version of the audio node. */
  html?: string;
}

const baseAudioData: object = {};

export const AudioData = {
  fromJSON(object: any): AudioData {
    const message = { ...baseAudioData } as AudioData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.audio =
      object.audio !== undefined && object.audio !== null
        ? Media.fromJSON(object.audio)
        : undefined;
    message.disableDownload =
      object.disableDownload !== undefined && object.disableDownload !== null
        ? Boolean(object.disableDownload)
        : undefined;
    message.coverImage =
      object.coverImage !== undefined && object.coverImage !== null
        ? Media.fromJSON(object.coverImage)
        : undefined;
    message.name =
      object.name !== undefined && object.name !== null
        ? String(object.name)
        : undefined;
    message.authorName =
      object.authorName !== undefined && object.authorName !== null
        ? String(object.authorName)
        : undefined;
    message.html =
      object.html !== undefined && object.html !== null
        ? String(object.html)
        : undefined;
    return message;
  },

  toJSON(message: AudioData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.audio !== undefined &&
      (obj.audio = message.audio ? Media.toJSON(message.audio) : undefined);
    message.disableDownload !== undefined &&
      (obj.disableDownload = message.disableDownload);
    message.coverImage !== undefined &&
      (obj.coverImage = message.coverImage
        ? Media.toJSON(message.coverImage)
        : undefined);
    message.name !== undefined && (obj.name = message.name);
    message.authorName !== undefined && (obj.authorName = message.authorName);
    message.html !== undefined && (obj.html = message.html);
    return obj;
  },
};
